import { render, staticRenderFns } from "./CaigouGoods.vue?vue&type=template&id=6ca33898&scoped=true"
import script from "./CaigouGoods.vue?vue&type=script&lang=js"
export * from "./CaigouGoods.vue?vue&type=script&lang=js"
import style0 from "./CaigouGoods.vue?vue&type=style&index=0&id=6ca33898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca33898",
  null
  
)

export default component.exports